export default __webpack_public_path__ + "static/media/egg.136e54c6.png";